import { Switch } from "@headlessui/react";
import { classNames } from "../utils/formatters";

type TProps = {
  label?: string;
  value?: boolean;
  onChange: (value?: boolean) => void;
};

export default function ToggleSwitch({ label, value, onChange }: TProps) {
  return (
    <div className="flex gap-x-1 items-center">
      <span className="text-sm">{label}</span>
      <Switch
        checked={value}
        onChange={onChange}
        className={classNames(
          value ? "bg-orange-500" : "bg-gray-200",
          "relative inline-flex h-4 w-8 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            value ? "translate-x-4" : "translate-x-0",
            "pointer-events-none inline-block h-3 w-3 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
          )}
        />
      </Switch>
    </div>
  );
}
